import { render, staticRenderFns } from "./MethodPaidEdit.vue?vue&type=template&id=2b7665c9&scoped=true&"
import script from "./MethodPaidEdit.vue?vue&type=script&lang=js&"
export * from "./MethodPaidEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7665c9",
  null
  
)

export default component.exports